import React,{useState} from "react";
import { CAMPAIGN_ALL_LINK } from "../../../constants/constants";
import { TIMEZONES } from "../../../constants/timezones";
import client from "../../../api";
import { notifyError, notifyErrorInBottom, notifySuccess } from "../../../helper";
import { useParams } from "react-router-dom";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

const ScheduleLaterCampaignModelWindow = (props) => {
    const { setToggleModelWindow, toggleModelWindow } = props;
    const api = client();
    const {campaignID} = useParams('');
    const [loading, setLoading] = useState(false);
    const [selectedDateTime, setSelectedDateTime] = useState(new Date());
    const [timezone, setTimezone] = useState('');
    const [error, setError] = useState({start_time:'',start_timezone:''});
    // Handle date and time change
    const handleChange = (date) => {
        setSelectedDateTime(date);
    };
    
    const onBlur = (e) => {
        if(e.target.value === ''){
            setError({...error,[e.target.name]:'Field is required'});
        }
    }

    const onFocus = (e) => {
        setError({...error,[e.target.name]:''});
    }

    const handleScheduleLater = async () => {
        try{
            if(selectedDateTime !== '' && timezone !== ''){
                setLoading(true);
                const payload = {
                    campaigns_id : [campaignID], 
                    status : "scheduled",
                    start_time: selectedDateTime.toISOString(),
                    start_time_zone:timezone,
                    time_offset: selectedDateTime.getTimezoneOffset()
                }
                
                const response = await api.post('/v1/campaign/status/update', payload);
                if(response.status === 200 || response.status === 201){
                    notifySuccess('Campaign has been scheduled successfully');
                    setLoading(false);
                    setTimeout(()=>{
                        //setShowAccountDeleteModelWindow(!showAccountDeleteModelWindow);
                        window.location.href = CAMPAIGN_ALL_LINK;
                        
                    },1000);
                } 
            } else {
                notifyErrorInBottom('Please validate the required field(s).');
            }               
        } catch(error){
            console.log('error.message',error);
            setLoading(false);
            if(error.status === 400) notifyError('Bad Request. Unable to schedule this campaign. Please try again.');
        }
    }
   
    return(<>
        <div className="model-window">
            <div className="overlay"></div>
            <div className="model-view">
                <div className="inner-view">
                    <h2>Schedule Campaign</h2>
                    <p>The following campaign will be scheduled as per the time and the campaign will start at that time.</p>
                    <div className="form-fields">
                        <div className="field-wrap">
                            <label className="label-xs">Schedule Date and Time</label>
                            <DatePicker
                                name="start_time"
                                selected={selectedDateTime} // The selected date and time
                                onChange={handleChange} // Update the state with the new date and time
                                showTimeSelect // Enable time selection
                                dateFormat="Pp" // Date and time format
                                timeFormat="HH:mm" // 24-hour format for time
                                timeIntervals={15} // Set the time intervals to 15 minutes
                                timeCaption="Time" // Caption for the time input
                                minDate={new Date()} // Optional: Set minimum date to current date
                                onBlur={onBlur}
                                onFocus={onFocus}
                            />
                            {error?.start_time ? <span className="validation-error">{error?.start_time}</span>:''}
                        </div>

                        <div className="field-wrap">
                            <select 
                                 name="start_timezone" 
                                className="selectbox"
                                value={timezone} 
                                onChange={(e)=>(
                                    setTimezone(e.target.value))
                                }
                                onFocus={onFocus}
                                onBlur={onBlur}
                            >
                                <option value={''}>Timezone</option>
                                {TIMEZONES.map((zone,i)=>(<option key={i} value={zone}>{zone}</option>))}
                            </select>
                            {error?.start_timezone ? <span className="validation-error">{error?.start_timezone}</span>:''}
                        </div>

                    </div>
                    <div className="button-group">
                        <button 
                            type="button" 
                            className={loading ? "delete-btn button--loading":"delete-btn"} 
                            disabled={loading}
                            onClick={()=>handleScheduleLater()}>
                                <span className="button--text">Schedule</span>
                        </button>                        
                        <button className="cancel-btn" onClick={()=>setToggleModelWindow(!toggleModelWindow)}>Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </>);
}

export default ScheduleLaterCampaignModelWindow;